import React from "react";
import "../../App.css";

const Homepage = () => {
  return (
    <div className="pageContent">
      <div className="aboutBlock">
        <div className="about-wrapper">
          <div className="home-itemT">
            <div className="home-contentT">
              <h3>
                This concept has demonstrated that the redistribution mechanism,
                at least in the form originally envisioned, is not technically
                feasible. However, it has also proven that truly decentralized
                on-chain gambling is possible.
              </h3>

              <h3>
                Development is now focused on a new project that will introduce
                a new token together with its own decentralized gambling
                platform under a new brand.
              </h3>

              <h4>
                <strong>Stay tuned</strong>
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Homepage;
